<template>
  <div>
    <v-snackbar v-model="getSuccess.success" color="success" :timeout="3500">
      {{
        getSuccess.successMessage
          ? getSuccess.successMessage
          : 'Cambios realizados con éxito'
      }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text @click="initRequest">Cerrar</v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="getError.error" color="error" :timeout="4500">{{
      getError.errorMessage
    }}</v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      snack: true
    }
  },

  computed: {
    ...mapGetters('user', ['getError', 'getSuccess'])
  },
  methods: {
    ...mapMutations('user', ['initRequest'])
  }
}
</script>

<style>
</style>